import { DentallyWizardService } from './../app/components/wizards/dentally/dentally-wizard.service';
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { AuthService } from "../auth/auth.service";

import { Router } from "@angular/router";
import { environment } from "../environments/environment";
//import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerComponent } from "../app/components/spinner/spinner.component";
import { OrgSettingsService } from "src/org-settings/org-settings.service";
import { AuthMsgService } from "src/auth/auth-msg.service";
import { WizardViewModel } from "../app/components/wizards/dentally/wizard-view-model";

@Component({
  selector: "app-auth-callback",
  templateUrl: "./auth-callback.component.html",
  styleUrls: ["./auth-callback.component.scss"],
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private orgService: OrgSettingsService,
    private msgService: AuthMsgService,
    private dentallyService: DentallyWizardService
  ) {}

  ngOnInit() {
     var win = window as any;

     const self = this;
     this.authService.completeAuthentication(() => {
        
     });
    if (environment.debug_mode) {
       console.log(
         "AuthCallbackComponent.isLoggedIn()=" + this.authService.isLoggedIn()
       );
       console.log(
         "AuthCallbackComponent.getUser()=" + this.authService.getUser()
       );
       console.log(
         "AuthCallbackComponent.isUserExpired()=" +
           this.authService.isLoggedIn()
       );
     }
   if (this.authService.isLoggedIn())
          this.router.navigateByUrl('/cases');
  }
}
